import React, { Component } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SalesReportBy from "./salesReportBy";
import SalesReportYearToDate from "./salesReportYearToDateBy";
import { monthOptions, yearOptions } from "../config";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../common/mapper";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class KacabReportByType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      subMenuVisible: false,
      isAllSelected: false,
      isSpecificSelected: false,
      month: null,
      year: null,
      dataCabang: [],
      kodeCabang: [],
      search: {},
      doSearch: false,
    };
  }

  componentDidMount = async () => {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
    await this.fetchDataCabang();
    this.fetchLeaderId();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (R.isNil(this.state.kodeCabang)) {
      this.setState((prevValue) => ({
        ...prevValue,
        kodeCabang: [],
      }));
    }
    if (!R.equals(prevState.doSearch, this.state.doSearch)) {
      console.log("doSearch", this.state.doSearch);
    }
  }

  fetchLeaderId = async () => {
    const idLeader = localStorage.getItem("idLeader");
    console.log(idLeader);

    const userId = localStorage.getItem("userId");
    console.log(userId);

    if (idLeader) {
      this.setState((prevValue) => ({
        ...prevValue,
        idLeader: idLeader,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      console.log(res);

      if (res.ok) {
        localStorage.setItem("idLeader", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  handleChangeDoSearch = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      doSearch: value,
    }));
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Type",
      args: null,
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleSearch = () => {
    const {
      dataCabang,
      kodeCabang,
      isAllSelected,
      isSpecificSelected,
      month,
      year,
    } = this.state;

    const kodeCabangList = isAllSelected
      ? dataCabang.map((item) => item.kodeCabang)
      : isSpecificSelected && kodeCabang?.length
        ? kodeCabang.map((item) => item.value)
        : [];

    const searchPayload = {
      kodeCabangList,
      month: month?.value,
      year: year?.value,
      teamLeaderEmployeeId: this.state.idLeader,
      salesId: null,
    };

    this.setState((prev) => ({
      ...prev,
      doSearch: true,
      search: searchPayload,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={this.state.isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={this.state.isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              isClearable
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!this.state.isSpecificSelected}
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
          </FlexView>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              isClearable
              id="select_options_month"
              box="search"
              name="month"
              containerclassname="width width-250px"
              placeholder="Bulan"
              menuPosition="fixed"
              options={monthOptions}
              value={this.state.month}
              onChange={(value, { name }) =>
                this.handleChangeSearchValue(name, value)
              }
            />
            <SimpleDDL
              isClearable
              id="select_options_year"
              box="search"
              name="year"
              containerclassname="width width-250px"
              placeholder="Tahun"
              menuPosition="fixed"
              options={yearOptions}
              value={this.state.year}
              onChange={(value, { name }) =>
                this.handleChangeSearchValue(name, value)
              }
            />
            <SimpleButton
              styles={{ marginBottom: "20px" }}
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Jualan Per Varian</Tab>
              <Tab>Laporan Jualan Per Varian Year To Date</Tab>
              <Tab>Laporan Jualan Per Tipe</Tab>
              <Tab>Laporan Jualan Per Tipe Year To Date</Tab>
              <Tab>Laporan Jualan Per Series</Tab>
              <Tab>Laporan Jualan Per Series Year To Date</Tab>
              <Tab>Laporan Jualan Per Sub Segmen</Tab>
              <Tab>Laporan Jualan Per Sub Segmen Year To Date</Tab>
            </TabList>
            <TabPanel>
              <SalesReportBy
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="variant"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportYearToDate
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="variant"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportBy
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="type"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportYearToDate
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="type"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportBy
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="series"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportYearToDate
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="series"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportBy
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="subSegment"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesReportYearToDate
                {...this.props}
                changeDoSearch={this.handleChangeDoSearch}
                doSearch={this.state.doSearch}
                tab="subSegment"
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(KacabReportByType);
